import {
  error,
  VXLIconTypeFragment,
} from 'services/graphql/fragments/Fragments';
import {
  AnalyticsEventFragment,
  TagFragment,
} from 'services/graphql/fragments/HomeTilesContentFragment';
import { gql } from 'urql';

const getSelfFundedOfferDetailsV2 = gql`
  query SelfFundedOfferDetailsV2($input: SelfFundedOfferDetailsInput!) {
    selfFundedOfferDetails(input: $input) {
      __typename
      ... on SelfFundedOfferDetailsSuccess {
        __typename
        id
        heroImage
        logoImage
        centerTag {
          ...TagFragment
        }
        statusText
        expirationText
        offerTitle: title
        descriptionItem {
          primaryText
          secondaryText
          lineFormat
          isDisabled
          accessibilityLabel
          showsChevron
          leadingAccessory {
            __typename
            ...VXLIconTypeFragment
          }
          trailingAccessory {
            ...TagFragment
          }
          onPressAction {
            __typename
          }
          primaryNumberOfLines
        }
        sectionOneTitle
        sectionOneContent {
          __typename
          content
          itemType
        }
        instructions {
          id
          icon
          text
        }
        termsTitle
        termsContent
        disclosureTitle
        disclosureContent
        disclosureClickAnalytics {
          ...AnalyticsEventFragment
        }
        legalText
        legalUrl
        footerButton {
          __typename
          id
          buttonText
          buttonStyle
          buttonOnClick {
            __typename
            ... on OpenURLNavigationAction {
              __typename
              url
              analyticsEvent {
                ...AnalyticsEventFragment
              }
            }
          }
        }
        displayAnalytics {
          ...AnalyticsEventFragment
        }
      }
      ... on SelfFundedOfferDetailsError {
        __typename
        ...error
      }
    }
  }
  ${error}
  ${TagFragment}
  ${VXLIconTypeFragment}
  ${AnalyticsEventFragment}
`;

export default getSelfFundedOfferDetailsV2;
